
import Header from "./components/Header";
import About from "./components/About"
import Profile from "./components/Profile"
import Skills from "./components/Skills"
import Projects from "./components/Projects"
import Resume from "./components/Resume";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Experience from "./components/Experience";

const sectionStyle = {
  marginBottom: '50px', 
  xs:'auto'// Adjust the value to increase or decrease the space between sections
 };
 const App = () => {
  return (
 <div xs = 'auto'>
  <Header></Header>
 <div  style={sectionStyle} >
 <About />
 </div>
 <div style={sectionStyle}>
 <Profile />
 </div>
 <div xs='auto' style={sectionStyle}>
 <Skills />
 </div>
  <div xs='auto' style={sectionStyle}>
 <Experience />
 </div>
 <div style={sectionStyle}>
 <Projects />
 </div>
 <div style={sectionStyle}>
 <Resume />
 </div>
 <div style={sectionStyle}>
 <Contact />
 </div>
 <div style={sectionStyle}>
 <Footer />
 </div>
 </div>
  );
 };

export default App;
